import type { ThemeDecoration } from '../../../types';

export const DECORATION_POSITIONS: ThemeDecoration['position'][] = [
  'top-left',
  'top-right',
  'bottom-left',
  'bottom-right',
  'top',
  'bottom',
  'left',
  'right',
];

export const ANIMATION_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'snow', label: 'Snow' },
  { value: 'confetti', label: 'Confetti' },
  { value: 'fireworks', label: 'Fireworks' },
];

export const TEXT_COLOR_MODE_OPTIONS = [
  { value: '', label: 'Auto (Dark text)' },
  { value: 'light', label: 'Light (for dark backgrounds)' },
  { value: 'dark', label: 'Dark (for light backgrounds)' },
];
